"use client";
/* eslint-disable react/no-unescaped-entities */
// Modules
import React from "react";
import { useRouter } from "next/navigation";
import { Container, ListGroup } from "react-bootstrap";

// Styles
import "./styles.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./report-vulnerability.module.scss";

const BugBounty = () => {
  const router = useRouter();

  return (
    <div className={styles.container}>
      <Container
        fluid
        className={`grey_text extra_sides_padding ${styles.container_margin}`}
      >
        <h1 className="heading_text light_black_text">
          Trio's
          <span className="primary_orange_text">
            {" "}
            Responsible disclosure policy
          </span>{" "}
        </h1>
        <p className="paragraph_text">
          Trio is committed to security, We care deeply about the safety and
          security of our customer’s data. We deeply value all those in the
          security community who help us ensure 100% security of all our systems
          at all times. We reward reporters for the responsible disclosure of
          in-scope issues and exploitation techniques.
        </p>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          How to Report a Vulnerability?
        </h4>
        <p className="paragraph_text grey_text">
          If you happen to have identified a vulnerability on any of our web or
          mobile app properties, we request you to follow the steps outlined
          below:
        </p>
        <ul>
          <li>
            Please submit the vulnerability report form with the necessary
            details to recreate the vulnerability scenario. This may include
            screenshots, videos or simple text instructions.
          </li>
          <li>
            If possible, share with us your contact details (phone number or
            Email), So that our security team can reach out to you if further
            inputs are needed to identify or close the problem.
          </li>
          <li>
            If the identified vulnerability can be used to potentially extract
            information of our customers or systems, or impair our system’s
            ability to function normally, then please refrain from actually
            exploiting such a vulnerability. This is absolutely necessary for us
            to consider your disclosure a responsible one.
          </li>
          <li>
            While we appreciate the inputs of Whitehat hackers, we may take
            legal recourse if the identified vulnerabilities are exploited for
            unlawful gains or getting access to restricted customer or system
            information or impairing our systems.
          </li>
          <li>
            Upon receiving your report, our team will start investigating the
            issue. We will keep you updated on the progress and may reach back
            for further details if needed.
          </li>
          <li>
            Of course, we want to compensate your effort, so for any valid
            vulnerabilities with a CVSS score of 4 or higher, we will reach back
            to you with a respective reward.
          </li>
          <li>
            If you come across any vulnerabilities in our products, please don't
            hesitate to report them by emailing us at{" "}
            <a href="mailto:security@triotech.co.in">security@triotech.co.in</a>
            .
          </li>
        </ul>
        <button
          className={`${styles.button_container}`}
          onClick={() => {
            router.push("/report-vulnerability/report");
          }}
        >
          Report Bug
        </button>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          Programme rules
        </h4>
        <ul>
          <li>
            Don't violate the privacy of other users, destroy data, disrupt our
            services, etc.
          </li>
          <li>
            Give us a reasonable time to respond to the issue so that Our team
            will try to triage all reports with priority to the severity,
            scenario and exploit complexity. We will notify you when the
            reported vulnerability is remediated, and you may confirm that the
            solution covers the vulnerability adequately.
          </li>
          <li>
            Only target your own accounts in the process of investigating any
            bugs/findings. Don't target, attempt to access, or otherwise disrupt
            the accounts of other users without the express permission of our
            team.
          </li>
          <li>
            Don't target our physical security measures, or attempt to use
            social engineering, spam, distributed denial of service (DDOS)
            attacks, etc.
          </li>
          <li>
            In case you find a severe vulnerability that allows system access,
            you must not proceed further.
          </li>
          <li>
            It is Trio’s decision to determine when and how bugs should be
            addressed and fixed. Disclosing bugs to a party other than Trio is
            forbidden, all bug reports are to remain at the reporter and Trio’s
            discretion.
          </li>
          <li>
            Threatening of any kind will automatically disqualify you from
            participating in the program. Exploiting or misusing the
            vulnerability for your own or others' benefit will automatically
            disqualify the report.
          </li>
          <li>
            Bug disclosure communications with Trio’s Security Team are to
            remain confidential. Researchers must destroy all artifacts created
            to document vulnerabilities (POC code, videos, screenshots) after
            the bug report is closed.
          </li>
        </ul>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          Eligibility
        </h4>
        <ul>
          <li>Be the first to report the issue to us.</li>
          <li>
            Must pertain to an item explicitly listed under Vulnerability
            Categories.
          </li>
          <li>
            Must contain sufficient information including a proof of concept
            screenshot, video, or code snippet where needed.
          </li>
          <li>
            You agree to participate in testing the effectiveness of the
            countermeasure applied to your report.
          </li>
          <li>You agree to keep any communication with Trio private.</li>
        </ul>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          Scope
        </h4>
        <ListGroup as="ol" numbered>
          <ListGroup.Item as="li">
            Any website that is owned by Tri O Tech
          </ListGroup.Item>
        </ListGroup>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          Qualifying Vulnerabilities
        </h4>
        <p className="paragraph_text grey_text">
          Any design or implementation issue that is reproducible and
          substantially affects the security of Trio users is likely to be in
          scope for the program. Common examples include:
        </p>
        <ul>
          <li>Injections</li>
          <li>Cross Site Scripting (XSS)</li>
          <li>Cross Site Request Forgery (CSRF)</li>
          <li>Remote Code Execution (RCE)</li>
          <li>Authentication/Authorisation flaws</li>
          <li>Domain take-over vulnerabilities</li>
          <li>
            Able to take-over other Trio user accounts (while testing, use your
            own another test account to validate)
          </li>
          <li>
            Any vulnerability that can affect the Trio Brand, user data and
            financial transactions
          </li>
        </ul>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          Exclusions
        </h4>
        <p className="paragraph_text grey_text">
          The following bugs are unlikely to be eligible:
        </p>
        <ul className={`${styles.custom_list}`}>
          <li>Vulnerabilities found through automated testing</li>
          <li>"Scanner output" or scanner-generated reports</li>
          <li>
            Publicly released CVE’s or 0-days in internet software within 90
            days of their disclosure
          </li>
          <li>
            "Advisory" or "Informational" reports that do not include any Trio
            testing or context
          </li>
          <li>
            Vulnerabilities requiring MITM or physical access to the victim’s
            unlocked device
          </li>
          <li>
            Denial of Service attacks
            <ul className={`${styles.hide_li_icon}`}>
              <li>SPF and DKIM issues</li>
              <li>Content injection</li>
              <li>Hyperlink injection in emails</li>
              <li>IDN homograph attacks</li>
              <li>RTL Ambiguity</li>
            </ul>
          </li>
          <li>Content Spoofing</li>
          <li>Vulnerabilities relating to Password Policy</li>
          <li>Full-Path Disclosure on any property</li>
          <li>Version number information disclosure</li>
          <li>
            Third-party applications on the Trio Application directory
            (identified by the existence of a "Report this app" link on the
            app's page). Please report vulnerabilities with these services to
            the creator of that specific application
          </li>
          <li>
            Clickjacking on pre-authenticated pages, or the non-existence of
            X-Frame-Options, or other non-exploitable clickjacking
            vulnerabilities
          </li>
          <li>
            CSRF-able actions that do not require authentication (or a session)
            to exploit
          </li>
          <li>
            Reports related to the following security-related headers:
            <ul className={`${styles.hide_li_icon}`}>
              <li>Strict Transport Security (HSTS)</li>
              <li>
                XSS mitigation headers (X-Content-Type and X-XSS-Protection)
              </li>
              <li>X-Content-Type-Options</li>
              <li>
                Content Security Policy (CSP) settings (excluding nosniff in an
                exploitable scenario)
              </li>
            </ul>
          </li>
          <li>Bugs that do not represent any security risk</li>
          <li>
            Security bugs in third-party applications or services built on the
            Trio API - please report them to the third party that built the
            application or service
          </li>
          <li>
            Security bugs in software related to an acquisition for a period of
            90 days following any public announcement
          </li>
          <li>HTTP TRACE or OPTIONS methods enabled</li>
          <li>
            Non-sensitive (i.e., non-session) cookies missing the Secure or
            HttpOnly flags
          </li>
          <li>Tap jacking</li>
          <li>
            Mobile client issues require a rooted device and/or outdated OS
            version or SSL pinning issues.
          </li>
          <li>Subdomain takeovers without supporting evidence</li>
          <li>Missing best practices in SSL/TLS configuration</li>
          <li>
            The Vulnerabilities that cannot be used to exploit other users or
            Trio -- e.g., self-XSS or having a user paste JavaScript into the
            browser console
          </li>
          <li>
            Open ports without an accompanying proof-of-concept demonstrating
            vulnerability
          </li>
        </ul>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          Acknowledgements
        </h4>
        <p className="paragraph_text grey_text">
          We do not have a bounty/cash reward program for such disclosures, but
          we express our gratitude for your contribution in different ways. For
          genuine ethical disclosures, we would be glad to publicly acknowledge
          your contribution in this section on our website. Of course, this will
          be done if you want a public acknowledgement.
        </p>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          Hall of Fame
        </h4>
        <p className="paragraph_text grey_text">
          {/* On behalf of over thousands of trio users, we would like to thank the
          following people for making a responsible disclosure to us: */}
          This is dedicated to recognizing the contributions of our top security
          researchers who have helped us improve the security of our systems and
          applications through their bug reports.
        </p>
        <p className="paragraph_text grey_text">
          We are proud to showcase their names and acknowledge their outstanding
          efforts in making our service more secure and reliable for our users.
          We are grateful for the time and expertise that these researchers have
          invested in testing and reporting vulnerabilities to us. Their
          contributions have helped us identify and address potential security
          issues before they can be exploited by malicious actors.
        </p>
        {/* <h5>2023</h5>
        <ol>
          <li>
            <a href="https://www.linkedin.com/in/aditya-pratapsingh/">
              Aditya Pratap Singh
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/aditya-pratapsingh/">
              Arnav Jain
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/aditya-pratapsingh/">
              Piyush Bansal
            </a>
          </li>
        </ol>
        <h5>2022</h5>
        <ol>
          <li>
            <a href="https://www.linkedin.com/in/aditya-pratapsingh/">
              Aditya Pratap Singh
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/aditya-pratapsingh/">
              Arnav Jain
            </a>
          </li>
        </ol> */}
      </Container>
    </div>
  );
};

export default BugBounty;
